module.exports = __webpack_public_path__ + "static/media/YF94_1.1682c746.jpg";